import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { LoggedInGuard } from './loggedInGuard.service';

export const ROUTES: Routes = [
  { path: '', component: HomeComponent, canActivate: [LoggedInGuard] },
  { path: 'login', component: LoginComponent }
];



// WEBPACK FOOTER //
// /Users/mac-jeremy/Projets/fairepart/src/app/app.routes.ts